import React from 'react';
import './popup.css'; 

const Popup = ({ onClose }) => {
//   const handleClick = () => {
//     window.location.href = 'https://www.facebook.com/100062634594881/posts/931955898902221/?mibextid=WC7FNe&rdid=8Qk0SJl7U8COqMqC';
//   };
const handleClick = (e) => {
    console.log(e);
    if (e.target.className==='popup-image') {
        window.open('https://www.facebook.com/100062634594881/posts/931955898902221/?mibextid=WC7FNe&rdid=8Qk0SJl7U8COqMqC', '_blank');
    }
  };

  return (
    <div className="popup" onClick={handleClick}>
      <div className="popup-inner">
        <div className="popup-content">
          <img
            src={`${process.env.REACT_APP_R2_URL}/WhatsApp%20Image%202024-09-29%20at%2022.48.49%20(1).jpeg`}
            alt="Popup Background"
            className="popup-image"
          />
          <button className="popup-close" onClick={(e) => {e.stopPropagation(); onClose();}}>X</button>
        </div>
      </div>
    </div>
  );
};

export default Popup;
